"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _client = require("@apollo/client");

var _useInterval = _interopRequireDefault(require("./useInterval"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _default = function _default(_ref) {
  var _updateEntry$data;

  var _ref$mockData = _ref.mockData,
      mockData = _ref$mockData === void 0 ? [] : _ref$mockData,
      doFreshLoad = _ref.doFreshLoad,
      query = _ref.query,
      fetchAll = _ref.fetchAll,
      noPoll = _ref.noPoll,
      subscriptionCreateDataKey = _ref.subscriptionCreateDataKey,
      subscriptionCreateVariables = _ref.subscriptionCreateVariables,
      subscriptionCreateMutation = _ref.subscriptionCreateMutation,
      subscriptionUpdateDataKey = _ref.subscriptionUpdateDataKey,
      subscriptionUpdateVariables = _ref.subscriptionUpdateVariables,
      subscriptionUpdateMutation = _ref.subscriptionUpdateMutation,
      subscriptionUpdateQuery = _ref.subscriptionUpdateQuery,
      variables = _ref.variables,
      dataKey = _ref.dataKey,
      skip = _ref.skip,
      _ref$onItemsChange = _ref.onItemsChange,
      onItemsChange = _ref$onItemsChange === void 0 ? function (items) {
    return null;
  } : _ref$onItemsChange;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var client = (0, _client.useApolloClient)();

  var _useQuery = (0, _client.useQuery)(query, {
    skip: !!skip,
    // pollInterval: 5000,
    variables: variables
  }),
      refetch = _useQuery.refetch,
      fetchMore = _useQuery.fetchMore,
      dumbLoading = _useQuery.loading,
      error = _useQuery.error,
      _useQuery$data = _useQuery.data;

  _useQuery$data = _useQuery$data === void 0 ? {} : _useQuery$data;
  var _useQuery$data$dataKe = _useQuery$data[dataKey];
  _useQuery$data$dataKe = _useQuery$data$dataKe === void 0 ? {} : _useQuery$data$dataKe;
  var nextToken = _useQuery$data$dataKe.nextToken,
      items = _useQuery$data$dataKe.items;
  var entry = (0, _client.useSubscription)(subscriptionCreateMutation, {
    skip: !subscriptionCreateMutation || !!skip,
    variables: subscriptionCreateVariables
  });
  var newObject = null; //entry?.data?.[subscriptionCreateDataKey];

  var onCreateLoading = false; //!!entry?.loading;
  // console.log("ENTRY", entry)

  var updateEntry = (0, _client.useSubscription)(subscriptionUpdateMutation, {
    skip: !subscriptionUpdateMutation || !!skip,
    variables: subscriptionUpdateVariables
  });
  var updatedObject = updateEntry === null || updateEntry === void 0 ? void 0 : (_updateEntry$data = updateEntry.data) === null || _updateEntry$data === void 0 ? void 0 : _updateEntry$data[subscriptionUpdateDataKey];
  var onUpdateLoading = !!(updateEntry === null || updateEntry === void 0 ? void 0 : updateEntry.loading); // console.log("NEW OB", entry?.data)
  // console.log("UPDATED OB", updateEntry?.data)

  var memoizedItems = (0, _react.useMemo)(function () {
    return items !== null && items !== void 0 ? items : [];
  }, [JSON.stringify(items)]);
  var handleItemsChange = (0, _react.useCallback)(function (items) {
    return onItemsChange(items);
  }, []);

  var clearResults = function clearResults() {
    return fetchMore({
      query: query,
      variables: _objectSpread(_objectSpread({}, variables), {}, {
        nextToken: null,
        limit: variables.limit
      }),
      // updateQuery: ({__typename, [dataKey]: {__typename: connectionTypename, items } = {}} = {}, { fetchMoreResult: {[dataKey]: {items: newItems }} }) => 
      updateQuery: function updateQuery(resp, resp2) {
        return console.log("resp", resp, resp2);
      }
    });
  }; //   !!__typename &&
  //   ({
  //     __typename,
  //     [dataKey]: {
  //       __typename: connectionTypename,
  //       nextToken,
  //       items: [
  //         ...newItems,
  //       ]
  //     }
  //   })
  // })


  var defaultLimit = 10;
  var handleRefresh = (0, _react.useCallback)(function (limit) {
    return fetchMore({
      query: query,
      variables: _objectSpread(_objectSpread({}, variables), {}, {
        nextToken: null,
        limit: limit !== null && limit !== void 0 ? limit : variables.limit
      }),
      updateQuery: function updateQuery() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            __typename = _ref2.__typename,
            _ref2$dataKey = _ref2[dataKey];

        _ref2$dataKey = _ref2$dataKey === void 0 ? {} : _ref2$dataKey;
        var connectionTypename = _ref2$dataKey.__typename,
            _ref2$dataKey$items = _ref2$dataKey.items,
            items = _ref2$dataKey$items === void 0 ? [] : _ref2$dataKey$items;

        var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
            newItems = _ref3.fetchMoreResult[dataKey].items;

        return _defineProperty({
          __typename: __typename
        }, dataKey, {
          __typename: connectionTypename,
          nextToken: nextToken,
          items: [].concat(_toConsumableArray(newItems), _toConsumableArray(items.filter(function (item) {
            return !newItems.find(function (i) {
              return i.id === item.id;
            });
          })))
        });
      }
    });
  }, [JSON.stringify(variables), nextToken]);
  var handleEndReached = (0, _react.useCallback)(function () {
    return console.log("loading more") || !nextToken ? function () {
      return null;
    }() : Promise.all([setLoading(true), fetchMore({
      query: query,
      variables: _objectSpread(_objectSpread({}, variables), {}, {
        nextToken: nextToken
      }),
      updateQuery: function updateQuery() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            __typename = _ref5.__typename,
            _ref5$dataKey = _ref5[dataKey];

        _ref5$dataKey = _ref5$dataKey === void 0 ? {} : _ref5$dataKey;
        var connectionTypename = _ref5$dataKey.__typename,
            _ref5$dataKey$items = _ref5$dataKey.items,
            items = _ref5$dataKey$items === void 0 ? [] : _ref5$dataKey$items;

        var _ref6 = arguments.length > 1 ? arguments[1] : undefined,
            _ref6$fetchMoreResult = _ref6.fetchMoreResult[dataKey],
            nextToken = _ref6$fetchMoreResult.nextToken,
            newItems = _ref6$fetchMoreResult.items;

        return _defineProperty({
          __typename: __typename
        }, dataKey, {
          __typename: connectionTypename,
          nextToken: nextToken,
          items: [].concat(_toConsumableArray(items), _toConsumableArray(newItems.filter(function (item) {
            return !items.find(function (i) {
              return i.id === item.id;
            });
          })))
        });
      }
    }).then(function () {
      return console.log("done loading more") || setLoading(false);
    })]);
  }, [nextToken, JSON.stringify(variables)]);
  (0, _useInterval["default"])(function () {
    var _variables$limit;

    return !!items && handleRefresh(Math.max(items.length, (_variables$limit = variables.limit) !== null && _variables$limit !== void 0 ? _variables$limit : defaultLimit));
  }, !!noPoll ? 40000000 : 5000); // useEffect(() => {
  //   // console.log(memoizedItems?.length, !!nextToken)
  //   !!nextToken && 
  //   !memoizedItems?.length &&
  //   handleEndReached()
  // }, [memoizedItems, nextToken, handleEndReached])

  (0, _react.useEffect)(function () {
    handleItemsChange(memoizedItems);
  }, [handleItemsChange, memoizedItems]);
  (0, _react.useEffect)(function () {
    setLoading(dumbLoading);
  }, [dumbLoading]);
  (0, _react.useEffect)(function () {
    client.writeQuery({
      query: query,
      data: _defineProperty({}, dataKey, {
        nextToken: null,
        items: []
      })
    });
  }, [JSON.stringify(variables), dataKey]);
  (0, _react.useEffect)(function () {
    ((newObject === null || newObject === void 0 ? void 0 : newObject.id) || (updatedObject === null || updatedObject === void 0 ? void 0 : updatedObject.id)) && client.query({
      query: subscriptionUpdateQuery,
      variables: {
        id: (newObject === null || newObject === void 0 ? void 0 : newObject.id) || (updatedObject === null || updatedObject === void 0 ? void 0 : updatedObject.id)
      }
    });
  }, [newObject === null || newObject === void 0 ? void 0 : newObject.id, updatedObject === null || updatedObject === void 0 ? void 0 : updatedObject.id]);
  (0, _react.useEffect)(function () {
    ((newObject === null || newObject === void 0 ? void 0 : newObject.id) || (updatedObject === null || updatedObject === void 0 ? void 0 : updatedObject.id)) && handleRefresh();
  }, [handleRefresh, newObject === null || newObject === void 0 ? void 0 : newObject.id, updatedObject === null || updatedObject === void 0 ? void 0 : updatedObject.id]);
  (0, _react.useEffect)(function () {
    // refetch({nextToken: null})
    !!doFreshLoad && refetch({
      nextToken: null
    });
  }, [doFreshLoad]);
  (0, _react.useEffect)(function () {
    !!fetchAll && !!nextToken && handleEndReached();
  }, [fetchAll, nextToken]);
  !!error && console.log(error); // console.log(loading)

  return !!skip ? {} : {
    objects: memoizedItems,
    loading: !!fetchAll ? !!nextToken || !!loading : loading,
    onUpdateLoading: onUpdateLoading,
    onCreateLoading: onCreateLoading,
    error: error,
    nextToken: nextToken,
    refetch: refetch,
    handleRefresh: handleRefresh,
    handleEndReached: handleEndReached,
    clearResults: clearResults
  };
};

exports["default"] = _default;